import React from 'react';
import { useTheme } from '@components/theme';
import styles from './ReadMore.module.scss';

interface IReadMoreProps {
  children: React.ReactElement;
  className?: string;
  contentClassName?: string;
  expanded: boolean;
  setExpanded: (expanded: boolean) => void;
}

/**
 * Styles and truncates child component and appends a "Read More" / "Read Less" button.
 */
export default function ReadMore(props: IReadMoreProps) {
  const {
    children,
    className = '',
    contentClassName = '',
    expanded,
    setExpanded
  } = props;

  const theme = useTheme();

  return (
    <div className={ `${styles.Container} ${className}` }>
      {React.cloneElement(
        children,
        {
          className: `
            ${theme.styles.Body}
            ${styles.Content}
            ${expanded ? styles.isExpanded : ''}
            ${contentClassName}
          `
        },
        children.props.children,
        <button
          className={ `${styles.ReadLessButton} ${expanded ? styles.isExpanded : ''}` }
          onClick={ () => setExpanded(!expanded) }
          type="button"
        >
          <strong>Read Less</strong>
        </button>
      )}
      <button
        className={ `${styles.ReadMoreButton} ${expanded ? styles.isExpanded : ''}` }
        onClick={ () => setExpanded(!expanded) }
        type="button"
      >
        <strong>Read&nbsp;More</strong>
      </button>
    </div>
  );
}
